<template>
  <div class="cadastro-usuario">
    <v-container fluid>
      <h1 class="titulo"> Cadastros Contratos </h1>

      <div class="box-table">
        <v-skeleton-loader :loading="loadingTable" :transition="'fade-transition'" height="500" type="table">
          <v-data-table :headers="headers" :search="search" :items="listaItens" width="300px" flat hide-default-footer
            :loading="loadingPag" :items-per-page.sync="itemsPerPage" class="table-installations">
            <template v-slot:top>

              <BrToolBar @search="buscar"
                :configFilter="{ listaSelect: itemSelectKeys, getItens: getItens, jsonData: false }" :addlFilter="true"
                :labelTextField="'Nome'" />
              <expansionPanelDefault :handleClick="montarLabelFiltro">
                <v-row class="justify-end filter-contrato-name">
                  <v-col cols="12" md="12" class="py-0 mb-2">
                    <div class="d-flex align-center">
                      <v-text-field append-icon="search" :label="'Nome do contrato:'" single-line hide-details
                        v-on:keyup.enter="buscar(textSearch)" v-model.trim="textSearch" color="primary" solo dense />
                      <v-btn tile :color="variables.colorPrimary" dark class="modal-cadastro-btn-cadastrar ml-3"
                        @click="buscar(textSearch)">Buscar</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </expansionPanelDefault>
            </template>




            <template v-slot:item.action="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small @click="editItem(item)" tile outlined :color="variables.colorPrimary" class="mr-2"
                    v-on="on">
                    Editar
                  </v-btn>
                </template>
                <span>{{ item.id }}</span>

              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn tile outlined :color="variables.colorInfo" class="mr-2" v-on="on"> Informações
                  </v-btn>

                </template>
                <TooltipContratos :item="item" />
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-if="permiteAcao($route, 'delete')" class="mr-2" small @click="deleteItem(item)" tile outlined
                    :color="variables.colorError" v-on="on">
                    Excluir
                  </v-btn>
                </template>
                <span>{{ item.id }}</span>
              </v-tooltip>
            </template>

            <template v-slot:footer>
              <div class="wrapper-footer">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalItens }}
                </div>
                <v-pagination v-model="page" :length="numberOfPages" circle :disabled="disabled" :total-visible="7"
                  class="box-table-paginacao" v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </div>

      <v-btn class="mx-2 fab-cadastrar-usuario" fab color="primary" @click="cadastrar">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line
import { errorSnackbar, successSnackbar } from '@/core/service/utils'

/**
 * MIXIN
 */
import listagemTables from '@/views/mixins/listagemTables'
import Events from '@/core/service/events'
export default {
  name: 'CadastroAfiliadoContratos',
  components: {
    BrToolBar: () => import('./components/toolbar'),
    TooltipContratos: () => import('./components/tooltipContratos'),
    expansionPanelDefault: () => import('@/views/components/expansionPanelDefault')
  },
  mixins: [listagemTables],
  mounted() {
    this.getProducts()
    this.getComissions()
    this.getTypesCondicoes()
    Events.$on('reload::table::index', () => {
      this.loadingPag = true
      this.getItens().finally(() => {
        this.loadingPag = false
      })

    })
  },

  data: () => ({
    textSearch: '',
    headers: [
      { align: 'start', class: 'table-header', text: 'ID', value: 'id' },
      { align: 'start', class: 'table-header', text: 'Nome', value: 'name' },
      { align: 'start', class: 'table-header', text: 'Tipo', value: 'types.name' },
      { align: 'start', class: 'table-header', text: 'Descrição', value: 'types.description' },
      { align: 'end', class: 'table-header', text: '', value: 'action', sortable: false },
    ],
    loadingBtnsBloqueios: false
  }),
  computed: {
    ...mapGetters('afiliadosContratos', ['listaItens', 'totalItens', 'item']),
    ...mapGetters('roles', ['permiteAcao']),
    itemSelectKeys() {
      return {
        'ContractsAffiliateId': '',
        'ContractsAffiliate:name': '',
        AffiliatesContractTypes: {
          contractTypeId: ''
        },
        ComissionTypes: {
          comissionTypeId: ''
        }

      }
    }
  },

  methods: {
    ...mapActions('afiliadosContratos', ['getItens', 'getTypesContrato', 'getItem', 'deletarItem', 'getComissions', 'getTypesCondicoes', 'getProduct', 'getProducts']),
    montarLabelFiltro() {
      Events.$on('autoCompleteEntities::getSearchText', (val) => { this.terminalTextSelected = val })
      let labelFiltro = [
        {
          label: 'Nome Contrato:',
          value: this.loteriaTextSelected
        }
      ]
      // codBilhete, entity
      return labelFiltro
    },
    editItem(item) {
      this.loadingPag = true
      const dados = Object.assign({}, item)
      if (dados.contractTypeId !== 'CPA') {
        this.getProduct(dados)
      }
      this.getItem(dados).then(() => {
        Events.$emit('cadastro::openModalCadastro', dados)
      }).catch(() => {
        errorSnackbar('Error ao selecionar o item')
      }).finally(() => {
        this.loadingPag = false
      })
    },
    buscar(val) {

      this.loadingPag = true
      this.objCampoBusca['_addlFilter'] = { "ContractsAffiliate:name_ilike": `${val}%` }
      this.getItens({ _addlFilter: { "ContractsAffiliate:name_ilike": `${val}%` } })
        .then(result => {
          if (result.data.totalItens < 1) {
            errorSnackbar('Não há dados disponíveis')
          }
        })
        .catch(err => {
          errorSnackbar(err.error)
        })
        .finally(() => { this.loadingPag = false })
    },
  }
}
</script>

<style lang="scss">
@import '~@/assets/styles/components/table';

.filter-contrato-name {
  max-width: 30% !important;
  margin-top: 10px;
}

.v-tooltip__content {
  opacity: 1 !important;
}

.v-data-table thead tr th,
.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  color: $colorPrimary !important;
}

.box-table {
  // border-top: 5px solid $colorPrimary;
  // border-top-left-radius: 0 !important;
  // border-top-right-radius: 0 !important;

  .v-data-table-header-mobile {
    display: none;
  }
}

.fab-cadastrar-usuario {
  position: fixed;
  z-index: 1;
  bottom: 25px;
  right: 5px;

  @media (min-width: 599px) {
    display: none !important;
  }
}

.table-installations {
  table {
    @media (min-width: 1260px) {
      min-width: 1270px !important;

      td {
        padding: 0 5px !important;
      }
    }
  }

  .table-header-name {
    width: 150px !important;
  }

  .text-name {
    width: 150px !important;
    display: inline-block;
    line-height: 0.9;
  }
}

.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
  margin-bottom: 0 !important;
}
</style>
